import React, { useCallback, useEffect, useRef } from 'react';
import { createUseStyles } from 'react-jss';
import { useSetting } from '../../hooks/useSetting';
import pawBackgroundImage from '../../assets/images/paw2.png';

const useStyles = createUseStyles({
    paw: {
        display: 'none',
        position: 'absolute',
        willChange: 'transform',
        width: 300,
        height: 1800,
        transformOrigin: 'top center',
        zIndex: 20,
        borderTopLeftRadius: 250,
        borderTopRightRadius: 250,
        pointerEvents: 'none',
        '&::before': {
            content: '""',
            display: 'block',
            width: 85,
            transform: 'translateX(-50%)',
            left: '50%',
            top: 100,
            bottom: 0,
            boxShadow: '0 0 100px rgba(0, 0, 0, 0.9)',
            opacity: 0.3,
            position: 'absolute',
            zIndex: -2,
        },
        '&::after': {
            content: '""',
            display: 'block',
            inset: 0,
            position: 'absolute',
            zIndex: -1,
            backgroundImage: `url(${pawBackgroundImage})`,
            backgroundSize: '100%',
            backgroundPosition: 'center -55px',
            backgroundRepeat: 'no-repeat',
        },
        '&.pressed::before': {
            transform: 'translateX(-50%) translateY(-10px)',
            opacity: 0.9,
        },
    },
});

export const Paw = () => {
    const [ showPaw ] = useSetting('showPaw', true);
    const styles = useStyles();
    const ref = useRef<HTMLDivElement>(null);
    const updatePaw = useCallback((e: MouseEvent, pressed?: boolean) => {
        if (!ref.current) {
            return;
        }
        const xFrac = e.clientX / window.innerWidth;
        const deg = 10 + 15 * (1 - xFrac);
        let yOffset = 0;
        if (pressed === true || e.buttons === 1) {
            yOffset = -50;
        }
        ref.current.classList.toggle('pressed', e.buttons === 1);
        ref.current.style.transform = `translateX(-50%) translate(${e.clientX}px, ${e.clientY + yOffset}px) rotate(-${deg}deg)`;
        ref.current.style.display = 'initial';
    }, []);

    const handleMouseMove = useCallback((e: MouseEvent) => {
        updatePaw(e);
    }, [ updatePaw ]);

    useEffect(() => {
        const onDrag = (e: DragEvent) => {
            updatePaw(e, true);
        };
        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mousedown', handleMouseMove);
        window.addEventListener('mouseup', handleMouseMove);
        document.addEventListener('dragover', onDrag);
        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mousedown', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseMove);
            document.removeEventListener('dragover', onDrag);
        };
    }, [ handleMouseMove ]);

    return showPaw ? (
        <div ref={ref} className={styles.paw}>
        </div>
    ) : null;
};
